import React from 'react'

import { Avatar, Box, InfoDot, Text, useToggle } from '@factorialco/deprecated-design-system'
import arc from 'assets/images/payroll/arc.svg'
import bookkepperBubble from 'assets/images/payroll/bookkeeper-bubble.svg'
import companyChart from 'assets/images/payroll/company-chart.svg'
import hrBubble from 'assets/images/payroll/hr-bubble.svg'
import leadBubble from 'assets/images/payroll/lead-bubble.svg'
import { motion } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

import FakeInput from 'modules/payroll_bundle/pages/SelfServicePage//components/welcomeStep/FakeInput'
import CardHeader from 'modules/payroll_bundle/pages/SelfServicePage/components/welcomeStep/CardHeader'
import * as styles from 'modules/payroll_bundle/pages/SelfServicePage/index.vanilla.css'

const UPDATES = 'updates'
const COMPANY = 'company'
const COMPENSATIONS = 'compensations'
const ELEMENT_SIZE = '528px'

const Content = () => {
  const [hasClickedList, setHasClickedList] = React.useState<string[]>([])
  const [openUpdates, toggleUpdates] = useToggle()
  const [openCompany, toggleCompany] = useToggle()
  const [openCompensations, toggleCompensations] = useToggle()

  const clickedOnHeader = (value: string) => {
    if (hasClickedList.includes(value)) return
    const newList = [...hasClickedList]
    newList.push(value)

    setHasClickedList(newList)
  }

  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Box justifyContent="center" width="full" alignItems="center">
        <Text.Header1 weight="semibold">
          {i18n.t('payroll_bundle.onboarding.welcome_step.title')}
        </Text.Header1>
      </Box>

      <Box
        justifyContent="center"
        alignItems="center"
        maxWidth="s600"
        paddingTop="s24"
        paddingBottom="s12"
      >
        <img src={arc} alt="arc" />
      </Box>

      <Box maxWidth="s400" justifyContent="center" alignItems="center">
        <Text.Normal color="grey800" className={styles.alignText}>
          {i18n.t('payroll_bundle.onboarding.welcome_step.sub_headline')}
        </Text.Normal>
      </Box>

      <Box paddingY="s64">
        <Box flexDirection="row" gap="s64">
          <motion.img
            src={bookkepperBubble}
            animate={{
              y: ['-14%', '14%'],
            }}
            transition={{
              y: {
                duration: 1,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'mirror',
              },
            }}
          />

          <motion.img
            src={hrBubble}
            animate={{
              y: ['-20%', '20%'],
            }}
            transition={{
              y: {
                duration: 0.9,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'mirror',
              },
            }}
          />

          <motion.img
            src={leadBubble}
            animate={{
              y: ['-16%', '16%'],
            }}
            transition={{
              y: {
                duration: 1.15,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'mirror',
              },
            }}
          />
        </Box>
      </Box>

      <Box height="full" width="full" flexDirection="row" gap="s24">
        <Box
          alignItems="flexEnd"
          flexDirection="column"
          gap="s24"
          height="full"
          width="full"
          style={{
            flex: '1',
          }}
        >
          <Box
            style={{
              width: ELEMENT_SIZE,
            }}
            height="s200"
            background="grey000White"
            borderRadius={{
              all: 'abs016',
            }}
            border={{
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            <CardHeader
              open={openUpdates}
              toggle={toggleUpdates}
              title={i18n.t('payroll_bundle.onboarding.welcome_step.card_updates.title')}
              {...(hasClickedList.includes(UPDATES)
                ? { hasPulseAnimation: false }
                : { hasPulseAnimation: true })}
              onHandle={() => clickedOnHeader(UPDATES)}
            />

            {!openUpdates ? (
              <>
                <Box
                  justifyContent="spaceBetween"
                  alignItems="center"
                  flexDirection="row"
                  width="full"
                  paddingY="s12"
                  paddingX="s16"
                >
                  <Box flexDirection="row" alignItems="center">
                    <Avatar label="test" url="https://randomuser.me/api/portraits/men/66.jpg" />
                    <Box paddingLeft="s12">
                      <Text.Normal>Tom Thompson</Text.Normal>
                    </Box>
                  </Box>

                  <Text.Normal>
                    {i18n.t('payroll_bundle.onboarding.welcome_step.card_updates.row_description')}
                  </Text.Normal>
                </Box>

                <Box
                  justifyContent="spaceBetween"
                  alignItems="center"
                  flexDirection="row"
                  width="full"
                  paddingY="s12"
                  paddingX="s16"
                  border={{
                    top: {
                      width: 's1',
                      style: 'solid',
                      color: 'grey400',
                    },
                  }}
                >
                  <Box flexDirection="row" alignItems="center">
                    <Avatar label="test" url="https://randomuser.me/api/portraits/women/64.jpg" />
                    <Box paddingLeft="s12">
                      <Text.Normal>Hellen Sky</Text.Normal>
                    </Box>
                  </Box>
                  <Box flexDirection="row">
                    <Text.Normal stroked>40.000€</Text.Normal>
                    <Text.Normal>&nbsp;→ 50.000€</Text.Normal>
                  </Box>
                </Box>
              </>
            ) : (
              <Box flexWrap="wrap" paddingX="s16" paddingY="s12">
                <Text.Normal>
                  {i18n.t('payroll_bundle.onboarding.welcome_step.card_updates.explanation')}
                </Text.Normal>
              </Box>
            )}
          </Box>

          <Box
            style={{
              width: ELEMENT_SIZE,
            }}
            height="s200"
            background="grey000White"
            borderRadius={{
              all: 'abs016',
            }}
            border={{
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            <CardHeader
              open={openCompensations}
              toggle={toggleCompensations}
              title={i18n.t('payroll_bundle.onboarding.welcome_step.card_compensations.title')}
              {...(hasClickedList.includes(COMPENSATIONS)
                ? { hasPulseAnimation: false }
                : { hasPulseAnimation: true })}
              onHandle={() => clickedOnHeader(COMPENSATIONS)}
            />

            {!openCompensations ? (
              <Box cursor="default">
                <Box
                  justifyContent="spaceBetween"
                  alignItems="center"
                  flexDirection="row"
                  width="full"
                  paddingY="s12"
                  paddingX="s16"
                >
                  <Box flexDirection="row" alignItems="center">
                    <Avatar label="test" url="https://randomuser.me/api/portraits/men/36.jpg" />
                    <Box paddingLeft="s12">
                      <Text.Normal>Joe Doe</Text.Normal>
                    </Box>
                  </Box>
                  <Box flexDirection="row" gap="s12">
                    <FakeInput title="100" subtitle="EUR" />
                    <FakeInput
                      title={i18n.t(
                        'payroll_bundle.onboarding.welcome_step.card_compensations.row_compensation_1'
                      )}
                      hasChevron
                    />
                  </Box>
                </Box>

                <Box
                  justifyContent="spaceBetween"
                  alignItems="center"
                  flexDirection="row"
                  width="full"
                  paddingY="s12"
                  paddingX="s16"
                  border={{
                    top: {
                      width: 's1',
                      style: 'solid',
                      color: 'grey400',
                    },
                  }}
                >
                  <Box flexDirection="row" alignItems="center">
                    <Avatar label="test" url="https://randomuser.me/api/portraits/women/34.jpg" />
                    <Box paddingLeft="s12">
                      <Text.Normal>Martha Green</Text.Normal>
                    </Box>
                  </Box>

                  <Box flexDirection="row" gap="s12">
                    <FakeInput title="2" subtitle="hrs" />
                    <FakeInput title="30" subtitle="mins" />
                    <FakeInput
                      title={i18n.t(
                        'payroll_bundle.onboarding.welcome_step.card_compensations.row_compensation_2'
                      )}
                      hasChevron
                    />
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box flexWrap="wrap" width="full" paddingX="s16" paddingY="s12">
                <Text.Normal>
                  {i18n.t('payroll_bundle.onboarding.welcome_step.card_compensations.explanation')}
                </Text.Normal>
              </Box>
            )}
          </Box>
        </Box>

        <Box
          style={{
            flex: '1',
          }}
          height="full"
        >
          <Box
            height="full"
            background="grey000White"
            borderRadius={{
              all: 'abs016',
            }}
            style={{
              width: ELEMENT_SIZE,
            }}
            border={{
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            <CardHeader
              open={openCompany}
              toggle={toggleCompany}
              title={i18n.t('payroll_bundle.onboarding.welcome_step.card_company_cost.title')}
              {...(hasClickedList.includes(COMPANY)
                ? { hasPulseAnimation: false }
                : { hasPulseAnimation: true })}
              onHandle={() => clickedOnHeader(COMPANY)}
            />

            {!openCompany ? (
              <Box height="full">
                <Box
                  flexDirection="row"
                  justifyContent="spaceBetween"
                  paddingX="s32"
                  paddingTop="s24"
                  paddingBottom="s12"
                  gap="s24"
                >
                  <Box flexDirection="column" gap="s2" flexGrow>
                    <Text.Normal color="grey800" weight="medium">
                      {i18n.t(
                        'payroll_bundle.onboarding.welcome_step.card_company_cost.month_cost'
                      )}
                    </Text.Normal>
                    <Text.Header2 color="grey1000" weight="medium">
                      355.000,00 €
                    </Text.Header2>
                  </Box>

                  <Box flexDirection="column" gap="s2" flexGrow>
                    <Text.Normal color="grey800" weight="medium">
                      {i18n.t('payroll_bundle.onboarding.welcome_step.card_company_cost.year_cost')}
                    </Text.Normal>
                    <Text.Header2 color="grey1000" weight="medium">
                      2.995.145,00 €
                    </Text.Header2>
                  </Box>
                </Box>

                <Box paddingX="s32" height="full">
                  <Box paddingY="s12">
                    <Text.Normal color="grey800" size="200" weight="medium">
                      {i18n.t(
                        'payroll_bundle.onboarding.welcome_step.card_company_cost.cost_evolution'
                      )}
                    </Text.Normal>
                  </Box>
                  <Box height="s140">
                    <img src={companyChart} />
                  </Box>

                  <Box flexDirection="row" gap="s16" height="full">
                    <Box flexDirection="row" alignItems="center" gap="s4">
                      <InfoDot size="medium" color={'tangerine1000'} />
                      <Text.Normal size="200" color="grey800" weight="medium">
                        {i18n.t(
                          'payroll_bundle.onboarding.welcome_step.card_company_cost.bonus_info'
                        )}
                      </Text.Normal>
                    </Box>

                    <Box flexDirection="row" alignItems="center" gap="s4">
                      <InfoDot size="medium" color={'purple1000'} />
                      <Text.Normal size="200" color="grey800" weight="medium">
                        {i18n.t(
                          'payroll_bundle.onboarding.welcome_step.card_company_cost.expenses_info'
                        )}
                      </Text.Normal>
                    </Box>

                    <Box flexDirection="row" alignItems="center" gap="s4">
                      <InfoDot size="medium" color={'viridian800'} />
                      <Text.Normal size="200" color="grey800" weight="medium">
                        {i18n.t(
                          'payroll_bundle.onboarding.welcome_step.card_company_cost.base_salary_info'
                        )}
                      </Text.Normal>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box height="full">
                <Box paddingX="s16" paddingY="s12" flexWrap="wrap" width="full" height="full">
                  <Text.Normal overflowWrap>
                    {i18n.t(
                      'payroll_bundle.onboarding.welcome_step.card_company_cost.explanation_1'
                    )}
                  </Text.Normal>
                  <Box paddingTop="s24">
                    <Text.Normal overflowWrap>
                      {i18n.t(
                        'payroll_bundle.onboarding.welcome_step.card_company_cost.explanation_2'
                      )}
                    </Text.Normal>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Content
